<template>
  <div class="brand-list">
    <div class="table-search">
      <el-form ref="form" :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="品牌名称：" prop="brandName">
          <el-input v-model="form.brandName" placeholder="请输入品牌名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="success"
            v-if="isShowBatch"
            @click="handleConfig"
          >批量设置</el-button>
          <el-button
            type="success"
            v-if="!isShowBatch"
            @click="handleBatchShelves(1)"
          >批量上架</el-button>
          <el-button
            type="success"
            v-if="!isShowBatch"
            @click="handleBatchShelves(0)"
          >批量下架</el-button>
          <el-button type="primary" @click="handleInputChange">查询</el-button>
          <el-button type="primary" @click="handleAdd">添加</el-button>
          <el-button type="primary" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @select="handleSingleChange"
        @select-all="handleAllchange"
      >
        <el-table-column type="selection" align="center"></el-table-column>
        <el-table-column prop="brandSort" label="排序" align="center"></el-table-column>
        <el-table-column prop="brandName" label="品牌名称" align="center"></el-table-column>
        <el-table-column prop="brandNameEnglish" label="品牌英文名" align="center"></el-table-column>
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.brandState">上架</span>
            <span v-else>下架</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="125px">
          <template slot-scope="scope">
            <span
              class="upShelves"
              v-if="!scope.row.brandState"
              @click="handleShelves(scope.row.id,1)"
            >上架</span>
            <span
              class="downShelves"
              v-else
              @click="handleShelves(scope.row.id,0)"
            >下架</span>
            <span class="view" @click="handlePreview(scope.row)">预览</span>
            <el-popover
              popper-class="wechatCode"
              placement="top"
              width="60"
              trigger="click">
              <img :src="scope.row.brandQrCode" alt class="wechatImg" />
              <span class="wechat" slot="reference">小程序码</span>
            </el-popover>
            <span class="del" @click="handleDel(scope.row.id)">删除</span>
            <span class="editor" @click="handleEditor(scope.row.id)">编辑</span>
            <span class="path" @click="openDialog(scope.row.brandPath)">页面路径</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <copyDialog :visible="visible" :configPath="brandPath" @close="visible = false"/>
    <Preview
      :visible="previewVisible"
      :selectId="currentCellId"
      @close="handleClosePreview"
    />
  </div>
</template>
<script>
import { getBrandList, updateBrandUpAndDown, deleteBrand } from '@/api/brand';
import Preview from '@/components/h5/brandPage.vue';
import copyDialog from '@/components/copyDialog';
import Pagination from '@/components/Pagination';
import batch from '@/mixins/batch';
import preview from '@/mixins/mobile';

export default {
  mixins: [batch, preview],
  name: 'BrandList',
  data() {
    return {
      visible: false,
      brandPath: '',
      form: {
        brandName: '',
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  components: {
    Pagination,
    copyDialog,
    Preview,
  },
  mounted() {
    this.getBrandList();
  },
  methods: {
    getBrandList() {
      this.loading = true;
      return getBrandList({
        brandName: this.form.brandName,
        page: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.success) {
          this.loading = false;
          const { total, list } = res.data;
          if (list && Array.isArray(list)) {
            this.tableData = list;
            this.total = parseInt(total, 10);
            return this.tableData;
          }
          return false;
        }
        this.$message.error(res.message);
        return false;
      });
    },
    // 批量上下架
    updateBrandUpAndDown(ids, brandState) {
      updateBrandUpAndDown(ids, brandState).then((res) => {
        if (res.success) {
          this.getBrandList();
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 输入查询
    handleInputChange() {
      this.currentPage = 1;
      this.getBrandList();
    },
    // 单个上下架
    handleShelves(id, brandState) {
      this.updateBrandUpAndDown(id, brandState);
    },
    // 批量上下架
    handleBatchShelves(brandState) {
      const tempArr = this.getDealArr();
      if (tempArr.length > 0) {
        this.updateBrandUpAndDown(tempArr, brandState);
        this.clearSelection();
      } else {
        this.$message.warning('请选择需要至少一条数据后操作！');
      }
    },
    // 删除
    handleDel(id) {
      deleteBrand(id).then((res) => {
        if (res.success) {
          this.$message.success('删除成功');
          this.getBrandList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getBrandList();
    },
    // 页面路径
    openDialog(path) {
      this.brandPath = path;
      this.visible = true;
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getBrandList();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getBrandList().then((res) => {
        if (res) {
          this.findSelectionItem(res);
        }
      });
    },
    // 编辑
    handleEditor(id) {
      this.$router.push({
        name: 'BrandEditor',
        query: {
          id,
        },
      });
    },
    // 添加品牌
    handleAdd() {
      this.$router.push({ name: 'BrandAdd' });
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~assets/css/mixins'
.demo-form-inline
  flex-row()
  justify-content space-between
.view, .wechat, .del, .editor, .path, .upShelves, .downShelves
  color #1890ff
  cursor pointer
.view, .wechat, .del, .editor, .upShelves, .downShelves
  margin-right 20px
.memberImg
  width 150px
  height 100px
.wechatImg
  width 150px
  height 150px
.dialog-footer
  text-align center
</style>
<style lang="stylus">
.wechatCode
  background rgba(0, 0, 0, 0)
  min-width 150px
  padding 0
  border none
  margin 0
</style>
